import './styles.scss'
import React from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import { useSelector } from 'react-redux'

import { MnemonicsBadge } from 'components/mnemonics'
import { getStaticImage } from 'utils/statics'
import { ALLOWED_DOMAINS } from 'constants/index'
import flagEnvDisplay from 'constants/flagEnvDisplay'

const getCurrentSection = (pathname) => {
  if (pathname.includes('users')) return 'conversations'
  if (pathname.includes('assignations')) return 'assigned-conversations'
  if (pathname.includes('lists')) return 'conversation-lists'
  if (pathname.includes('search')) return 'conversation-search'
  if (pathname.includes('inchat')) return 'conversation-inchat'
  return 'conversations'
}

const SideMenuHeader = ({
  countUsersInLists,
  cv_lists,
  isListsAvailable,
  listsWithUsers,
  onChangeToSearch,
  powerUser
}) => {
  const { push } = useHistory()
  const { pathname } = useLocation()
  const activeSection = getCurrentSection(pathname)

  const { inchat } = useSelector(store => store.modules)

  return (
    <div className='side-menu-header'>
      {
        powerUser.onlyAssignedConversations
          ? null
          : (
            <button
              className={`side-menu-header__section-btn ${activeSection === 'conversations' ? 'side-menu-header__section-btn--active' : ''}`}
              onClick={() => push('/dashboard/conversations/users')}
            >
              <figure>
                <img
                  src={activeSection === 'conversations'
                    ? getStaticImage('/icons/orange-brand/icon-user-slim-primary-dark.svg')
                    : getStaticImage('/icons/orange-brand/icon-user-slim-grey.svg')
                  }
                  alt='Conversations'
                />
              </figure>
              <MnemonicsBadge medium location='poolMain' showTooltip showRealNumber />
            </button>
          )
      }
      <button
        className={`side-menu-header__section-btn ${activeSection === 'assigned-conversations' ? 'side-menu-header__section-btn--active' : ''}`}
        onClick={() => push('/dashboard/conversations/assignations')}
      >
        <figure>
          <img
            src={activeSection === 'assigned-conversations'
              ? getStaticImage('/icons/orange-brand/icon-user-asign-primary-dark.svg')
              : getStaticImage('/icons/orange-brand/icon-user-asign-grey.svg')
            }
            alt='Assigned conversations'
          />
        </figure>
        <MnemonicsBadge medium location='poolAssigned' showTooltip showRealNumber />
      </button>
      <button
        className={`side-menu-header__section-btn ${activeSection === 'conversation-lists' ? 'side-menu-header__section-btn--active' : ''}`}
        onClick={() => push('/dashboard/conversations/lists')}
      >
        <figure>
          <img
            src={activeSection === 'conversation-lists'
              ? getStaticImage('/icons/orange-brand/icon-folder-primary-dark.svg')
              : getStaticImage('/icons/orange-brand/icon-folder-grey.svg')
            }
            alt='Conversation lists'
          />
        </figure>
        {ALLOWED_DOMAINS.type === 'TA' ? (
          countUsersInLists(cv_lists.lists)
        ) : (
          <MnemonicsBadge medium location='poolLists' showRealNumber value={listsWithUsers} />
        )}
      </button>
      <button
        className={`side-menu-header__section-btn ${activeSection === 'conversation-search' ? 'side-menu-header__section-btn--active' : ''}`}
        onClick={() => {
          push('/dashboard/conversations/search')
          onChangeToSearch()
        }}
      >
        <figure>
          <img
            src={activeSection === 'conversation-search'
              ? getStaticImage('/icons/orange-brand/icon-search-primary-dark.svg')
              : getStaticImage('/icons/orange-brand/icon-search-grey.svg')
            }
            alt='Conversation search'
          />
        </figure>
      </button>
      {
        inchat.isActive && flagEnvDisplay.displayInChat ? (
          <button
            className={`side-menu-header__section-btn ${activeSection === 'conversation-inchat' ? 'side-menu-header__section-btn--active' : ''}`}
            onClick={() => push('/dashboard/conversations/inchat')}
          >
            <figure>
              <img
                src={activeSection === 'conversation-inchat'
                  ? getStaticImage('/icons/orange-brand/icon-inchat.svg')
                  : getStaticImage('/icons/orange-brand/icon-inchat-grey.svg')
                }
                alt='InChat conversations'
              />
            </figure>
            <MnemonicsBadge medium location='inchat' showTooltip showRealNumber />
          </button>
        ) : null
      }
    </div>
  )
}

export default SideMenuHeader
